// extracted by mini-css-extract-plugin
export var errorIcon = "_k0-1";
export var nameLogo = "_k0-0";